import { render, staticRenderFns } from "./CardProfitLoss.vue?vue&type=template&id=220938d9&scoped=true&"
import script from "./CardProfitLoss.vue?vue&type=script&lang=ts&"
export * from "./CardProfitLoss.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220938d9",
  null
  
)

export default component.exports